import { changeEmail } from '@cognitoforms/api/services/authentication';
import { startStage } from 'src/utilities/journey/activation';
import { resolveSignupUserStart } from 'src/utilities/journey/registry';

export default [{
	path: '/auth',
	component: () => import(/* webpackChunkName: 'Auth' */ 'src/layouts/Auth.vue'),
	children: [
		{
			path: '/login',
			name: 'login',
			component: () => import(/* webpackChunkName: 'AuthContainer' */ './AuthContainer.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Log In'
			}
		},
		{
			path: '/signup',
			name: 'signup',
			component: () => import(/* webpackChunkName: 'AuthContainer' */ './AuthContainer.vue'),
			props: route => ({ ...route.query, ...route.params }),
			beforeEnter: (to, from, next) => {
				startStage(resolveSignupUserStart(to.query.source, to.query.returnUrl));
				next();
			},
			meta: {
				title: 'Sign Up'
			}
		},
		{
			path: '/verify-email-change',
			name: 'verify-email-change',
			component: () => import(/* webpackChunkName: 'VerifyEmailChange' */ './VerifyEmailChange.vue'),
			props: route => ({ ...route.query, ...route.params }),
			beforeEnter: (to, from, next) => {
				// If the user is verifying an email address change, change their email and continue to My Account page.
				if (to.query.code) {
					changeEmail(to.query.code)
						.then(res => {
							// successful log in
							next({ path: '/myaccount', query: { code: to.query.code } });
						}).catch(() => {
							next({ path: '/verify-email-change', query: { invalidCode: true } }); // Show error message if invalid
						});
				}
				else {
					next();
				}
			}
		},
		{
			path: '/api-connection',
			name: 'api-connection',
			component: () => import(/* webpackChunkName: 'ApiConnection' */ './ApiConnection.vue'),
			props: route => ({ ...route.query, ...route.params })
		},
		{
			path: '/enable-multifactor',
			name: 'enable-multifactor',
			component: () => import(/* webpackChunkName: 'EnableMultifactor' */ './EnableMultifactor.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Two-Factor Authentication'
			}
		}
	]
}];